import React from "react";
import { Controller } from "react-hook-form";
import type { SubmissionDefaultValuesPath } from "common/services/formBuilderService";
import type { PathArray } from "common/utils/formStructure";
import Select from "../../../../../../../Inputs/Select";
import {
  getUiSchemaPropertyFormPath,
  useBuilderFormContext,
  useBuilderWatch,
} from "../../../form/form";

type NumberDynamicDefaultInputProps = {
  fieldPath: PathArray;
  isReadOnly: boolean;
};

export function NumberDynamicDefaultInput({
  fieldPath,
  isReadOnly,
}: NumberDynamicDefaultInputProps) {
  const { control } = useBuilderFormContext();

  const defaultValuePathPropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "defaultValuePath",
  );
  const defaultValuePath = useBuilderWatch(defaultValuePathPropertyFormPath);

  return (
    <Controller
      control={control}
      name={defaultValuePathPropertyFormPath}
      render={({ field }) => {
        return (
          <Select
            label="Dynamic default value"
            value={defaultValuePath ?? null}
            isClearable={true}
            name={defaultValuePathPropertyFormPath}
            options={numberDynamicDefaultInputOptions}
            onChange={value => {
              field.onChange(value ?? undefined);
            }}
            disabled={isReadOnly}
          />
        );
      }}
    />
  );
}

const numberDynamicDefaultInputOptions: Array<{
  value: SubmissionDefaultValuesPath;
  label: string;
}> = [
  {
    value: "parcel.improvementValue",
    label: "Parcel > Improvement value",
  },
  {
    value: "property.improvementValue",
    label: "Property > Improvement value",
  },
  {
    value: "property.latitude",
    label: "Property > Latitude",
  },
  {
    value: "property.longitude",
    label: "Property > Longitude",
  },
  {
    value: "property.sisd.adjustmentRatio",
    label: "Property > SI/SD > Adjustment ratio",
  },
];
